// Keep the first behaviour untill it's corrected everywhere.
const iconEyes = document.querySelectorAll(".eye-icon");

if (iconEyes) {
  iconEyes.forEach((iconEye) => {
    iconEye.addEventListener("click", (e) => {
      const input = e.target.parentNode.querySelector("input.input-password");
      if (!(input)) return;

      if (input.getAttribute("type") === "password") {
        input.setAttribute("type", "text");
      } else {
        input.setAttribute("type", "password");
      }
    })
  })
}

// Hide and show password with toggle behaviour on icon.
$(document).ready(() => {
  $('.toggle-password').click(function(){
    $(this).children().toggleClass('d-none');
    let input = $(this).prev();

    if (input.hasClass('invalid-feedback')) {
      input = $(this).prevAll().eq(1);
    }

    input.attr('type', input.attr('type') === 'password' ? 'text' : 'password');
  });
});
